<template>
  <nav-item
    v-if="canUseAIChat"
    class="ai-chat-nav-item"
    :title="$t('aiChat.title')"
    icon="message"
    :active="open"
    hover-color="beige"
    @click="toggle"
  />
</template>

<script setup>
import NavItem from '@/components/navigation/NavItem.vue';
import useAIChat from '@/composables/ai-chat/ai-chat';
import useAiChatPanel from '@/composables/ai-chat/ai-chat-panel';

const { canUseAIChat } = useAIChat();
const { open, toggle } = useAiChatPanel();
</script>
